export default "__VITE_PUBLIC_ASSET__19537a8a__"